import { render } from "./EditUserAIFormulaModalContent.vue?vue&type=template&id=b32222b0&lang=true"
import script from "./EditUserAIFormulaModalContent.vue?vue&type=script&lang=js"
export * from "./EditUserAIFormulaModalContent.vue?vue&type=script&lang=js"

import "./EditUserAIFormulaModalContent.vue?vue&type=style&index=0&id=b32222b0&lang=css"
script.render = render

export default script